<mat-form-field *ngIf="variables.length > 0">
  <ng-container *ngIf="!isMultiple">
    <mat-select
      [(value)]="selected"
      [disabled] = "disabled"
      (selectionChange)="selectionChanged($event)"
    >
      <mat-select-filter
        [placeholder]="'Filter'"
        [array]=""
        (filteredReturn)="filteredList = $event"
      ></mat-select-filter>
      <mat-option *ngIf="selectCaption != ''">Select</mat-option>
      <mat-option *ngFor="let item of filteredList" [value]="item">
        {{ item[displayMember] }}
      </mat-option>
    </mat-select>
  </ng-container>
  <ng-container *ngIf="isMultiple">
    <ng-container *ngIf="noTags">
      <span style="font-size: 12px; position: absolute;display: flex;top: 6px;">Select Tags</span>
    </ng-container>
<!--     
    <ng-container *ngIf="noAssests">
      <span style="font-size: 12px; position: absolute;display: flex;top: 6px;">Select Assests</span>
    </ng-container> -->
    <mat-select
      cdkConnectedOverlay
      [(value)]="selected"
      (selectionChange)="selectionChanged($event)"
      (selectionChange)="selectionChangedAsset($event)"
      multiple
      disableOptionCentering
      panelClass="myPanelClass"
    >   
      <mat-select-filter
        [placeholder]="'Filter'"
        [displayMember]="displayMember"
        [array]="variables"
        (filteredReturn)="filteredList = $event"
      ></mat-select-filter>
      <mat-option *ngIf="selectCaption != ''">Select</mat-option>
      <mat-option *ngFor="let item of filteredList"  [value]="item">
        {{ item[displayMember] }}
      </mat-option>
    </mat-select>
  </ng-container>
</mat-form-field>
